import logoMadriwa from '../../../assets/img/logoMadriwa.png';

type MadriwaLogoProps = {
  size?: 'small' | 'medium' | 'large';
  className?: string;
};

const MadriwaLogo: React.FC<MadriwaLogoProps> = ({ size = 'small', className }) => {
  return (
    <div className={className}>
      <div
        className={
          size === 'small' ? 'w-32 sm:w-40' : size === 'medium' ? 'w-40 sm:w-60 ' : 'w-56 sm:w-60'
        }
      >
        <img className="w-full" src={logoMadriwa} alt="logo Madriwa" />
      </div>
    </div>
  );
};

export default MadriwaLogo;
